import React, { Component } from 'react'
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash, faUser, faPlus } from '@fortawesome/free-solid-svg-icons';
import AddAssessmentQuestion from './AddAssessmentQuestion'
import AssignAssessment from './AssignAssessment';
import AddAssessment from './AddAssessment';
import Loader from '../../../components/Loader/Loader';
import axios from 'axios';
import ToastComp from '../../../components/Toast/Toast';
import { API } from '../../../config/API';
import EditQuestions from './EditQuestions';
import EditAssessmentQuestion from './EditAssessmentQuestion';
import toast from 'react-hot-toast';

export default class Assessment extends Component {

  constructor() {
    super();
    this.columns = [
      {
        id: "id",
        name: 'ID',
        selector: row => row.id,
        grow: 0.2
      },
      {
        name: 'TITLE',
        selector: row => row.name,
        grow: 1.5
      },
      {
        name: 'TYPE',
        selector: props => this.formatType(props.assessmentType),
      },
      {
        name: 'CREATED DATE',
        selector: row => row.validfrom,
        grow: 0.75
      },
      {
        name: 'EXPIRY DATE',
        selector: row => row.validto,
        grow: 0.75
      },
      {
        cell: (row) => <button id={row.id} className='btn btn-success' onClick={() => this.addQuestion(row)}> <FontAwesomeIcon icon={faPlus} className='table-icon-inline' /> QUESTION</button>,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width: "150px"
      },
      {
        cell: (row) => <button id={row.id} className='btn btn-info' onClick={() => this.editAssessment(row)}> <FontAwesomeIcon icon={faEdit} className='table-icon-inline' />EDIT</button>,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        cell: (row) => <button id={row.id} className='btn btn-danger' onClick={() => this.deleteAssessment(row.id)}> <FontAwesomeIcon icon={faTrash} className='table-icon-inline' />DELETE</button>,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        cell: (row) => <button id={row.id} className='btn btn-warning' onClick={() => this.assignTrainCourse(row)}> <FontAwesomeIcon icon={faUser} className='table-icon-inline' />ASSIGN</button>,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    ]
    this.state = {
      data: [],
      fullData: [],
      toggleForm: false,
      toggleAssignForm: false,
      toggleAddForm: false,
      editForm: false,
      selectedQuestionType: '',
      loader: false,
      saveAlert: false,
      errorAlert: false,
      deleteAlert: false,
      addQAlert: false,
      assignAlert: false,
      unassignAlert: false,
      editQ: false,
      editIndividualQuestion: false
    }
    this.assessmentObj = {};
    this.qstnData = [];
    this.singleQuestionObj = {};

  }

  formatType = (type) => {
    const map = {
      1: "Objective",
      2: "Interactive",
      3: "Descriptive"
    }
    return map[type];
  }
  addQuestion = (row) => {
    this.assessmentObj = row;
    this.setState({ selectedQuestionType: row.assessmentType }, () => {
      this.setState({ toggleForm: true });
    })
  }
  assignTrainCourse = (obj) => {
    this.assessmentObj = obj;
    this.setState({ toggleAssignForm: true });
  }
  editAssessment = (obj) => {
    this.assessmentObj = obj;
    this.setState({ editForm: true });
  }
  componentDidMount() {
    this.loadAssessments();
  }
  //Function to create assessment
  createAssessment = (req) => {
    this.setState({ loader: true });
    axios.post(API.saveAssessment, req).then((res) => {
      if (res && res.data && res.data.status === 'S') {
        // this.setState({ saveAlert: true });
        toast.success('Assessment created successfully.');
      } else {
        // this.setState({ errorAlert: true });
        toast.error('Failed to create assessment.');
      }
    }).catch((er) => {
      // this.setState({ errorAlert: true });
      toast.error('An error occurred while creating assessment.');
    }).finally(() => {
      setTimeout(() => {
        this.setState({ loader: false });
        this.loadAssessments();
      }, 1000);
    })
  }
  //Edit Assessment
  editAssessmentCall = (req) => {
    this.setState({ loader: true });
    axios.post(API.editAssessment, req).then((res) => {
      if (res && res.data && res.data.status === 'S') {
        // this.setState({ saveAlert: true });
        toast.success('Assessment updated successfully.');
      } else {
        // this.setState({ errorAlert: true });
        toast.error('Failed to update assessment.');
      }
    }).catch((er) => {
      // this.setState({ errorAlert: true });
      toast.error('An error occurred while updating assessment.');
    }).finally(() => {
      setTimeout(() => {
        this.setState({ loader: false });
        this.loadAssessments();
      }, 1000);
    })
  }
  //Delete 
  deleteAssessment = (id) => {
    this.setState({ loader: true });
    axios.post(API.deleteAssessment, { id }).then((res) => {
      if (res && res.data && res.data.status === 'S') {
        // this.setState({ deleteAlert: true });
        toast.success('Assessment deleted successfully.');
      } else {
        // this.setState({ errorAlert: true });
        toast.error('Failed to delete assessment.');
      }
    }).catch((er) => {
      // this.setState({ errorAlert: true });
      toast.error('An error occurred while deleting assessment.');
    }).finally(() => {
      setTimeout(() => {
        this.setState({ loader: false });
        this.loadAssessments();
      }, 1000);
    })
  }
  //List Assessment
  loadAssessments = () => {
    this.setState({ editForm: false });
    this.setState({ toggleAddForm: false });
    this.setState({ toggleForm: false });
    this.setState({ loader: true });

    axios.get(API.listAssessment).then((res) => {
      if (res && res.data && res.data.status === "S") {
        const data = res.data.assessments;
        this.setState({ data });
        this.setState({ fullData: data });
      }
      this.setState({ loader: false });
    }).catch((er) => {
      this.setState({ loader: false });
    })
  }

  //unassign training
  unAssignAssessment = (data) => {
    this.setState({ loader: true });
    const req = {
      assessmentId: this.assessmentObj.id,
      dueDate: data.dueDate
    }
    const typeMap = {
      D: 'groupId',
      P: 'project',
      L: 'level'
    }
    //attach project/level/groupId key
    req[typeMap[data.type]] = data.selected;
    axios.post(API.unassignAssessment, req).then((res) => {
      if (res && res.data && res.data.status === 'S') {
        this.setState({ unassignAlert: true });
      } else {
        this.setState({ errorAlert: true });
      }
    }).catch((er) => {
      this.setState({ errorAlert: true });
    }).finally(() => {
      setTimeout(() => {
        this.setState({ loader: false });
        this.setState({ toggleAssignForm: false });
        this.loadAssessments();
      }, 1000);
    })
  }

  //assign training to department
  assignAssessment = (data) => {
    this.setState({ loader: true });
    const req = {
      assessmentId: this.assessmentObj.id,
      dueDate: data.dueDate
    }
    const typeMap = {
      D: 'groupId',
      P: 'project',
      L: 'level'
    }
    //attach project/level/groupId key
    req[typeMap[data.type]] = data.selected;
    axios.post(API.assignAssessment, req).then((res) => {
      if (res && res.data && res.data.status === 'S') {
        this.setState({ assignAlert: true });
      } else {
        this.setState({ errorAlert: true });
      }
    }).catch((er) => {
      this.setState({ errorAlert: true });
    }).finally(() => {
      setTimeout(() => {
        this.setState({ loader: false });
        this.setState({ toggleAssignForm: false });
        this.loadAssessments();
      }, 1000);
    })
  }
  //Save question
  saveQuestion = (req) => {
    this.setState({ loader: true });
    let url;
    if (this.state.selectedQuestionType === 1) {
      url = API.addAssessmentQuestion;
    } else if (this.state.selectedQuestionType === 2) {
      url = API.addAssessmentQuestion2;
    } else if (this.state.selectedQuestionType === 3) {
      url = API.addAssessmentQuestion3;
    }
    axios.post(url, req).then((res) => {
      if (res && res.data && res.data.status === 'S') {
        // this.setState({ addQAlert: true });
        toast.success('Question added successfully.');
      } else {
        // this.setState({ errorAlert: true });
        toast.error('Failed to add question.');
      }
    }).catch((er) => {
      // this.setState({ errorAlert: true });
      toast.error('An error occurred while adding question.');
    }).finally(() => {
      setTimeout(() => {
        this.setState({ loader: false });
        this.loadAssessments();
      }, 1000);
    })
  }
  //Final edit question
  editQuestionFinal = (req, type) => {
    this.setState({ loader: true });
    let url;
    if (type === 1) {
      url = API.editAssessmentQuestion;
    } else if (type === 2) {
      url = API.editAssessmentQuestion2;
    } else if (type === 3) {
      url = API.editAssessmentQuestion3;
    }
    axios.post(url, req).then((res) => {
      if (res && res.data && res.data.status === 'S') {
        // this.setState({ addQAlert: true });
        toast.success('Question updated successfully.');
      } else {
        // this.setState({ errorAlert: true });
        toast.error('Failed to update question.');
      }
    }).catch((er) => {
      // this.setState({ errorAlert: true });
      toast.error('An error occurred while updating question.');
    }).finally(() => {
      setTimeout(() => {
        this.setState({ loader: false });
        this.loadAssessments();
      }, 1000);
    })
  }
  //Open edit flow.
  goToEditQuesion = () => {
    this.setState({ editForm: false })
    this.setState({ loader: true });
    axios.get(API.listAssessment + "/" + this.assessmentObj.id).then((res) => {
      this.setState({ loader: false });
      if (res && res.data && res.data.status === 'S') {
        this.qstnData = res.data.questions;
        this.setState({ editQ: true });
      } else {
        this.setState({ errorAlert: true });
      }
    }).catch((er) => {
      this.setState({ loader: false });
      this.setState({ errorAlert: true });
    })
  }

  deleteTrQuestion = (id) => {
    this.setState({ editQ: false });
    this.setState({ loader: true });
    const req = {
      assessmentId: this.assessmentObj.id,
      questionId: [id]
    }
    axios.post(API.deleteAssessmentQuestion, req).then((res) => {
      if (res && res.data && res.data.status === 'S') {
        // this.setState({ deleteAlert: true });
        toast.success('Question deleted successfully.');
      } else {
        // this.setState({ errorAlert: true });
        toast.error('Failed to delete question.');
      }
    }).catch((er) => {
      // this.setState({ errorAlert: true });
      toast.error('An error occurred while deleting question.');
    }).finally(() => {
      setTimeout(() => {
        this.setState({ loader: false });
        this.loadAssessments();
      }, 1000);
    })

  }

  //Search fn
  filterData = (e) => {
    const key = e.target.value;
    let ar = [];
    this.state.fullData.forEach(element => {
      if (element.name.toLowerCase().indexOf(key.toLowerCase()) > -1)
        ar.push(element);
    });
    this.setState({ data: ar })
  }

  //open edit indiviual question
  openIndividualedit = (data) => {
    this.singleQuestionObj = data;
    this.setState({ editIndividualQuestion: true });
  }

  render() {

    return (
      <div>
        <Loader loading={this.state.loader}></Loader>
        {this.state.saveAlert ? <ToastComp case='assess-add' handler={() => { this.setState({ saveAlert: false }) }} /> : ""}
        {this.state.errorAlert ? <ToastComp case='error' handler={() => { this.setState({ errorAlert: false }) }} /> : ""}
        {this.state.deleteAlert ? <ToastComp case='delete' handler={() => { this.setState({ deleteAlert: false }) }} /> : ""}
        {this.state.addQAlert ? <ToastComp case='question-add' handler={() => { this.setState({ addQAlert: false }) }} /> : ""}
        {this.state.assignAlert ? <ToastComp case='assign-user' handler={() => { this.setState({ assignAlert: false }) }} /> : ""}
        {this.state.unassignAlert ? <ToastComp case='unassign-user' handler={() => { this.setState({ unassignAlert: false }) }} /> : ""}

        {this.state.editForm ? <AddAssessment editQ={this.goToEditQuesion} editCb={(req) => this.editAssessmentCall(req)} data={this.assessmentObj} edit={true} handler={() => this.setState({ editForm: false })} flag={this.state.editForm ? true : false} /> : ''}
        {this.state.toggleAddForm ? <AddAssessment createCb={(data) => this.createAssessment(data)} handler={() => this.setState({ toggleAddForm: false })} flag={this.state.toggleAddForm ? true : false} /> : ''}
        {this.state.toggleForm ? <AddAssessmentQuestion saveCb={(req) => this.saveQuestion(req)} data={this.assessmentObj} type={this.state.selectedQuestionType} handler={() => this.setState({ toggleForm: false })} flag={this.state.toggleForm ? true : false} /> : ''}
        {this.state.toggleAssignForm ? <AssignAssessment unassign={(data) => { this.unAssignAssessment(data) }} assign={(data) => { this.assignAssessment(data) }} data={this.assessmentObj} handler={() => this.setState({ toggleAssignForm: false })} flag={this.state.toggleAssignForm ? true : false} /> : ''}
        {this.state.editQ ? <EditQuestions editIndiviual={(data) => { this.openIndividualedit(data) }} deleteCB={(id) => this.deleteTrQuestion(id)} data={this.qstnData} fullData={this.assessmentObj} flag={this.state.editQ ? true : false} handler={() => this.setState({ editQ: false })} /> : ""}

        {this.state.editIndividualQuestion ? <EditAssessmentQuestion saveCall={(req, type) => this.editQuestionFinal(req, type)} data={this.singleQuestionObj} flag={this.state.editIndividualQuestion ? true : false} handler={() => this.setState({ editIndividualQuestion: false })} /> : ''}

        <div className='bread-crumb overflow-auto'>
          <div>
            <span className='breadcrumb-title'>
              <input type='button' className='btn' value='Home - Assessment'></input>
            </span>
            <span className='fr'>
              <input type='button' className='btn btn-success' value='ADD ASSESSMENT' onClick={() => this.setState({ toggleAddForm: true })}></input>
            </span>
          </div>
        </div>
        <div className='data-table-holder'>
          <div className='table-search-box'>
            <input type='text' placeholder="Search Here.." className='form-control' onChange={(e) => this.filterData(e)}></input>
          </div>
          <DataTable defaultSortFieldId="id"
            columns={this.columns}
            data={this.state.data} pagination striped

          />
        </div>
      </div>
    )
  }
}
